var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShipmentWarning = function SvgShipmentWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.906.5v3.327M11.313 5.5V3.827H.5v6.654a.83.83 0 0 0 .832.832H9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.5 3.827 1.248-2.404A1.66 1.66 0 0 1 3.195.5h5.423a1.66 1.66 0 0 1 1.489.923l1.206 2.404M11.313 7.75v3M11.313 13.5a.25.25 0 1 1 0-.5M11.313 13.5a.25.25 0 1 0 0-.5"
  }))));
};
export default SvgShipmentWarning;